import { Formik, Form, ErrorMessage } from "formik";
import React, { useState } from "react";
import * as yup from "yup";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Title } from "components/Title";
import useApp from "hooks/useApp";
import useAddPage from "hooks/useAddPage";
import { ProgressSpinner } from "primereact/progressspinner";
import  {validationSchema, formDefaultValues} from "./Funcionario.Validation";
import FuncionarioForm from "./Funcionario.Form";


const FuncionariosAddPage = (props) => {
    const app = useApp();
    const [CheckActive, setCheckActive] = useState(false);
    const [CheckGestor, setCheckGestor] = useState(false);

    //page hook where logics resides
    const pageController = useAddPage({
        props,
        formDefaultValues,
        afterSubmit,
    });

    // destructure and grab what the page needs
    const {
        formData,
        resetForm,
        handleSubmit,
        submitForm,
        pageReady,
        loading,
        saving,
        inputClassName,
    } = pageController;

    //event raised after form submit
    function afterSubmit(response) {
        app.flashMsg(props.msgTitle, props.msgAfterSave);
        resetForm();
        if (app.isDialogOpen()) {
            app.closeDialogs(); // if page is open as dialog, close dialog
        } else if (props.redirect) {
            app.navigate(`/funcionarios`);
        }
    }

    // page loading form data from api
    if (loading) {
        return (
            <div className="p-3 text-center">
                <ProgressSpinner style={{ width: "50px", height: "50px" }} />
            </div>
        );
    }

    //page has loaded any required data and ready to render
    if (pageReady) {
        return (
            <main id="FuncionariosAddPage" className="main-page">
                {props.showHeader && (
                    <section className="page-section mb-3">
                        <div className="container">
                            <div className="grid justify-content-between align-items-center">
                                {!props.isSubPage && (
                                    <div className="col-fixed ">
                                        <Button
                                            onClick={() => app.navigate(-1)}
                                            label=""
                                            className="p-button p-button-text "
                                            icon="pi pi-arrow-left"
                                        />
                                    </div>
                                )}
                                <div className="col ">
                                    <Title
                                        title="Adicionar novo"
                                        titleClass="text-2xl text-primary font-bold"
                                        subTitleClass="text-500"
                                        separator={false}
                                    />
                                </div>
                            </div>
                        </div>
                    </section>
                )}
                <section className="page-section ">
                    <div className="container">
                        <div className="grid ">
                            <div className="md:col-9 sm:col-12 comp-grid">
                                <div>
                                    <Formik
                                        initialValues={formData}
                                        validationSchema={validationSchema}
                                        onSubmit={(values, actions) =>
                                            submitForm(values)
                                        }
                                    >
                                        {(formik) => (
                                            <>
                                                <Form
                                                    className={`${!props.isSubPage
                                                        ? "card  "
                                                        : ""
                                                        }`}
                                                >

                                                    <FuncionarioForm
                                                        formik={formik}
                                                        formData={
                                                            formDefaultValues
                                                        }
                                                        inputClassName={inputClassName}
                                                        app={app}
                                                        setCheckActive={setCheckActive}
                                                        CheckActive={CheckActive}
                                                        setCheckGestor={setCheckGestor}
                                                        CheckGestor={CheckGestor}
                                                    />

                                                    {props.showFooter && (
                                                        <div className="text-center my-3">
                                                            <Button
                                                                onClick={(e) => {
                                                                    handleSubmit(
                                                                        e,
                                                                        formik
                                                                    )
                                                                }}
                                                                className="p-button-primary"
                                                                type="submit"
                                                                label="Enviar"
                                                                icon="pi pi-send"
                                                                loading={saving}
                                                            />
                                                        </div>
                                                    )}
                                                </Form>
                                            </>
                                        )}
                                    </Formik>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        );
    }
};

//page props and default values
FuncionariosAddPage.defaultProps = {
    primaryKey: "id",
    pageName: "funcionarios",
    apiPath: "funcionarios/add",
    routeName: "funcionariosadd",
    submitButtonLabel: "Enviar",
    formValidationError: "O formulário é inválido",
    formValidationMsg: "Por favor, preencha o formulário",
    msgTitle: "Criar registro",
    msgAfterSave: "Registro adicionado com sucesso",
    msgBeforeSave: "Deseja Salvar os Dados Agora?",
    showHeader: true,
    showFooter: true,
    redirect: true,
    isSubPage: false,
};
export default FuncionariosAddPage;
